import type { Market } from "@/lib/useMarket"
import type { QuickViewData } from "./types"
import MarginsCard from "./MarginsCard"
import GraphsSection from "./sections/GraphsSection"
import IncomingSection from "./sections/IncomingSection"
import PriceSection from "./sections/PriceSection"
import SalesSection from "./sections/SalesSection"
import { SectionCards } from "./sections/Section"
import StockByWarehouse from "./sections/StockByWarehouse"
import SupplySection from "./sections/SupplySection"

// The panel's sections, top to bottom, as the spec lists them; the three key
// numbers sit above them in the white top section. Each is a white card on
// the panel's tinted body.
export default function PanelBody({ data, market }: { data: QuickViewData; market: Market }) {
  return (
    <SectionCards.Provider value={true}>
      <div className="flex flex-col gap-3 p-4">
        <MarginsCard margins={data.margins} currency={data.currency} />
        <IncomingSection incoming={data.incoming} today={data.today} />
        <GraphsSection data={data} />
        <StockByWarehouse stock={data.warehouse_stock} marketName={market.name} />
        <PriceSection price={data.price} currency={data.currency} />
        <SalesSection sales={data.sales} today={data.today} />
        <SupplySection supply={data.supply} />
      </div>
    </SectionCards.Provider>
  )
}
